
import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { PaymentDialogReason } from "src/app/interfaces";
import { PaymentStore } from "src/app/store/payment.store";

export interface SubscriptionRequiredDialogData {
  hasActiveSubscription: boolean;
  reason: PaymentDialogReason;
}

@Component({
  selector: "app-subscription-required-dialog",
  standalone: true,
  imports: [MatButtonModule],
  templateUrl: "./subscription-required-dialog.component.html",
  styleUrls: ["./subscription-required-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class SubscriptionRequiredDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<SubscriptionRequiredDialogComponent>);
  private readonly paymentStore = inject(PaymentStore);
  public readonly data = inject<SubscriptionRequiredDialogData>(MAT_DIALOG_DATA);

  public get title(): string {
    if (this.data.reason === "softPrompt") {
      return "Unlock more tokens";
    }
    return "Subscription required";
  }

  public get description(): string {
    if (this.data.reason === "softPrompt") {
      return "You're nearing the end of your monthly quota. Upgrade now to unlock 1,000,000 tokens each month.";
    }
    return "Upgrade for a larger monthly allowance for the AI work used to understand questions, generate SQL, and build answers and charts.";
  }

  public close(): void {
    this.dialogRef.close(false);
  }

  public async upgrade(): Promise<void> {
    const redirectUrl = window.location.href;
    await this.paymentStore.startCheckout(redirectUrl);
    this.dialogRef.close(true);
  }
}
